import React from "react";
import styled, { css } from "styled-components";
import getBorderColor from "../../../utils/getBorderColor";
import unit from "../../../utils/unit";
var Wrapper = styled.div.withConfig({
  componentId: "sc-acfhsl-0"
})(function (_ref) {
  var $border = _ref.$border,
    $onColor = _ref.$onColor,
    theme = _ref.theme;
  var border = $border;
  var borders = $border;
  return css(["", " ", " ", " ", " ", ""], borders.top && css(["border-top:", " ", " ", ";"], unit(borders.top.width), borders.top.style, getBorderColor(theme, $onColor, borders.top.emphasis)), borders.right && css(["border-right:", " ", " ", ";"], unit(borders.right.width), borders.right.style, getBorderColor(theme, $onColor, borders.right.emphasis)), borders.bottom && css(["border-bottom:", " ", " ", ";"], unit(borders.bottom.width), borders.bottom.style, getBorderColor(theme, $onColor, borders.bottom.emphasis)), borders.left && css(["border-left:", " ", " ", ";"], unit(borders.left.width), borders.left.style, getBorderColor(theme, $onColor, borders.left.emphasis)), border.width && css(["border:", " ", " ", ";"], unit(border.width), border.style, getBorderColor(theme, $onColor, border.emphasis)));
});
function BorderOrg(_ref2) {
  var border = _ref2.border,
    onColor = _ref2.onColor,
    children = _ref2.children;
  return /*#__PURE__*/React.createElement(Wrapper, {
    $border: border,
    $onColor: onColor
  }, children);
}
export default BorderOrg;